import { render } from "./vision.vue?vue&type=template&id=520a8bba&scoped=true"
const script = {}

import "./vision.vue?vue&type=style&index=0&id=520a8bba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520a8bba"]])

export default __exports__